import { useState, useEffect } from 'react';
import { getMarketProfileFilterMarket } from '@intelligence/services/marketProfile';
import { getPCConsoleMarkets } from '@intelligence/pages/MarketProfile/_config/_testData';

export interface ResultInterface {
  region_country?: any[];

  [key: string]: any;
}

export interface CountryItem {
  name: string;
  enName: string;
}

const getCountryList = async ({
  entity_type,
}: {
  entity_type?: string;
}): Promise<CountryItem[]> => {
  try {
    const result: ResultInterface =
      (await getMarketProfileFilterMarket({
        entity_type,
        regions: entity_type === 'pc' || entity_type === 'console' ? getPCConsoleMarkets() : [],
      })) || {};

    const regionCountryList = result?.region_country || [];
    const countryData: CountryItem[] = [];

    regionCountryList.forEach((item) => {
      if (item.continent) {
        item?.country_set?.forEach((t) => {
          countryData.push({
            name: t?.name === 'Congo' ? 'Republic of the Congo' : t?.name,
            enName: t?.abbre,
          });
        });
      }
    });

    return countryData;
  } catch (err) {
    console.error('Error fetching country list:', err);
    throw err;
  }
};

interface UseCountriesHookResult {
  countries: CountryItem[];
  loading: boolean;
  error: Error | null;
}

export default function useCountriesHooks({
  entity_type,
}: {
  entity_type?: string;
}): UseCountriesHookResult {
  const [countries, setCountries] = useState<CountryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getCountryList({ entity_type });
        if (isMounted) {
          setCountries(data);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setError(err as Error);
          setCountries([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [entity_type]);

  return { countries, loading, error };
}
